import TextFieldRoot, { Props } from './TextField'

export default function TextField(props: Props) {
  return <TextFieldRoot {...props} />
}
